import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatPriceEUR(amount) {
    return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
    }).format(amount);
}

export const CREWS = [
    "Ciurma di Cappello di Paglia",
    "Marina",
    "Flotta dei 7",
    "4 Imperatori",
    "Armata Rivoluzionaria",
];
